<template>
    <div class="q-pb-md" style="display: inline-block; max-width: 400px;">
        <div class="q-px-md q-pt-sm">{{ label }}</div>
        <q-select v-model="choices"
                  class="q-mx-sm"
                  clearable
                  multiple
                  outlined
                  dense
                  use-chips
                  emit-value
                  map-options
                  option-label="text"
                  option-value="value"
                  :options="items"
                  popup-content-class="ag-custom-component-popup"
                  @update:model-value="updateFilter" />
    </div>
</template>

<script>
    export default {
        name: 'DropdownFilter',
        data: function () {
            return {
                choices: [],
                items: [],
            }
        },
        mounted() {
            const uniqueValues = {};
            this.params.api.forEachNode((node) => {
                const value = this.getNodeValue(node);

                if (value !== undefined || value !== null)
                    uniqueValues[value] = true;
            });

            this.items = Object.keys(uniqueValues).map(k => ({ text: k, value: k }));
        },
        computed: {
            label: function () {
                return this.params.label || 'Select Filter Values:';
            },
        },
        methods: {
            updateFilter() {
                if (!Array.isArray(this.choices))
                    this.choices = [];

                this.params.filterChangedCallback();
            },

            getNodeValue(node) {
                if (typeof this.params.getValue === 'function')
                    return this.params.getValue(node);

                const { api, colDef, column, columnApi, context } = this.params;
                return this.params.valueGetter({
                    api,
                    colDef,
                    column,
                    columnApi,
                    context,
                    data: node.data,
                    getValue: (field) => node.data[field],
                    node,
                });
            },

            // The following are used by ag-grid //
            doesFilterPass(params) {
                const { node } = params;

                const value = this.getNodeValue(node);

                return this.choices.length == 0 || this.choices.includes(value);
            },
            isFilterActive() {
                return this.choices.length > 0;
            },
            getModel() {
                if (this.active)
                    return { choices: this.choices };
            },
            setModel(model) {
                if (!model) {
                    this.choices = [];
                }
                else {
                    this.choices = model.choices;
                }
            },
        }
    }
</script>

<style scoped>

</style>